<template>
    <div class="component component__navigator">
        <div class="container">
            <div class="columns is-vcentered">
                <div class="column is-3-desktop">
                    <div class="columns is-variable">
                        <div class="column is-narrow">
                            <component-button
                                :size="'medium'"
                                :name="'component-navigator-back'"
                                :theme="'default'"
                                :to="backTo"
                            >{{ $t('shared.navigator.buttons.back') }}</component-button>
                        </div>
                    </div>
                </div>
                <div class="column is-6-desktop">
                    <div class="component__navigator_arrows">
                        <div class="columns is-block-mobile columns--margin-1-mobile is-variable">
                            <div class="column">
                                <component-button
                                    :align="'right'"
                                    :icon="true"
                                    :icon-name="'chevron-left'"
                                    :name="'component-navigator-previous'"
                                    :to="previousTo"
                                    :disabled="!previousTo"
                                    :theme="previousTo ? 'primary' : 'default'"
                                >{{ $t('shared.navigator.buttons.previous') }}</component-button>
                            </div>
                            <div class="column">
                                <component-button
                                    :align="'left'"
                                    :icon="true"
                                    :icon-name="'chevron-right'"
                                    :icon-align="'right'"
                                    :name="'component-navigator-next'"
                                    :to="nextTo"
                                    :disabled="!nextTo"
                                    :theme="nextTo ? 'primary' : 'default'"
                                >{{ $t('shared.navigator.buttons.next') }}</component-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column is-3-desktop">
                    <div class="columns is-variable">
                        <div class="column">
                            <component-button
                                ref="componentbuttonremove"
                                :align="'right'"
                                :icon="true"
                                :icon-name="'trash-2'"
                                :inverse="true"
                                :name="'medialibrary-header-remove'"
                                :theme="'secondary-dark'"
                                :notify-active="true"
                                :notify-title="removeNotifyTitle"
                                :notify-text="removeNotifyText"
                                :notify-submit-text="$t('shared.navigator.buttons.delete')"
                                :notify-submit-danger="true"
                                :notify-submit-animate-loading="true"
                                :notify-submit-animate-loading-name="'remove-media-notify'"
                                :notify-prevent-close="true"
                                @emit-notify-submit="emitRemove"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
export default {
  name: 'component-navigator',
  components: { ComponentButton },
  props: {
    backTo: {
      type: Object
    },
    nextTo: {
      type: Object
    },
    previousTo: {
      type: Object
    },
    removeNotifyTitle: {
      type: String,
      default: function () {
        return this.$t('shared.navigator.props.deleteItem')
      }
    },
    removeNotifyText: {
      type: String,
      default: function () {
        return this.$t('shared.navigator.props.areYouSure')
      }
    }
  },
  methods: {
    emitRemove () {
      this.$emit('emit-remove')
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/_componentnavigator.scss";
</style>
